/**
 * SoundParameter.ts
 */
export class SoundParameter {
}
//# sourceMappingURL=SoundParameter.js.map